exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-organizations-card-videos[data-v-617c99b4]{position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.page-organizations-card-videos__item[data-v-617c99b4]{position:relative;width:100%;max-width:560px;aspect-ratio:16/9;margin:0 auto}.page-organizations-card-videos__item[data-v-617c99b4] iframe{position:absolute;top:0;left:0;display:block;width:100%;height:100%;border:0}.page-organizations-card-videos__button[data-v-617c99b4]{position:absolute;z-index:1;cursor:pointer;border:0;border-radius:50%;width:32px;height:32px;background:#fff;color:#8164a6;font-size:28px;line-height:28px}.page-organizations-card-videos__button[data-v-617c99b4]:first-child{left:0}.page-organizations-card-videos__button_right[data-v-617c99b4]{right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-617c99b4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/organizations/card/videos/component.vue
// module id = 7657e44c2290462d0a4a
// module chunks = 1